import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeComponent from "@/components/home/HomeComponent.vue";
import RouteComponent from "@/components/route/RouteComponent.vue";
import MapComponent from "@/components/map/MapComponent.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "home",
        component: HomeComponent,
    },
    {
        path: "/route/:name",
        name: "route",
        component: RouteComponent
    },
    {
        path: "/map/:name",
        name: "map",
        component: MapComponent
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return {top: 0}
    }
});

export default router;
